import React, { useState, useRef, useEffect } from 'react';
import { Checkdevice } from '../../../../components';
import { iconwrapper } from '../../../../config/commonfunctions';
import { ADD_ICON, HEARTUSERLOGIN_ICON, RIGHTARROW_ICON, TICK_ICON } from '../../../../config/svgicons';
import { S3CLOUD_CLOUDFRONT_USERLOGIN } from '../../../../config/s3directories';
import './Directedline.css';
import { HOME_COLLECTION_READABLEVT_WEDDING_MAP, HOME_COLLECTION_VENDORTYPE_WEDDING, production } from '../../../../config/constants';
const imgs = [
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/De_Candolle_Rose_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Bloom_Collection_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Phlox_Amoena_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Epidendrum_Polyanthum_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Plum_Blossoms_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Purple_Monkey_Flower_T2.png",

    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/De_Candolle_Rose_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Bloom_Collection_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Phlox_Amoena_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Epidendrum_Polyanthum_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Plum_Blossoms_T2.png",
    "https://asset.weavebliss.com/assets/prebuilttemplate/smaller/Purple_Monkey_Flower_T2.png",
]

const iphone_rsvpwebsite_imgs = [
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/0.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/1.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/2.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/3.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/4.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/5.png',

    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/0.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/1.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/2.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/3.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/4.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/rsvp_website/short/5.png',
]

const guests_list_imgs = [
    'https://asset.weavebliss.com/assets/userlogin/directedline/guest_list/1.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/guest_list/2.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/guest_list/3.png',
    'https://asset.weavebliss.com/assets/userlogin/directedline/guest_list/4.png',
]

const food_list_imgs = [
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#F4900C" d="M8.512 15.93c0 1.657 1.974 2-.512 2-2.485 0-6-1-6-2s1.526-3 4.012-3 2.5 1.343 2.5 3z" /><path fill="#FFAC33" d="M27.88 33.027c-.098-.18-.25-.302-.418-.391C25.865 30.931 27 28.93 27 28.93c0-.553 1-2 0-2l-1 1c-1 1-1 4-1 4h-2c-.553 0-1 .447-1 1 0 .553.447 1 1 1h1.107l-.222.12c-.486.263-.667.869-.404 1.355s.869.667 1.356.404l2.639-1.427c.486-.262.667-.868.404-1.355zm-7 0c-.098-.18-.25-.302-.418-.391C18.865 30.931 20 28.93 20 28.93c0-.553 1-2 0-2l-1 1c-1 1-1 4-1 4h-2c-.553 0-1 .447-1 1 0 .553.447 1 1 1h1.108l-.222.12c-.486.263-.667.869-.404 1.355s.869.667 1.356.404l2.639-1.427c.485-.262.666-.868.403-1.355z" /><path fill="#FFCC4D" d="M35.217 17.305c-1.342 0-7.904 4.613-11.553-5.375-.005-.014-.012-.024-.018-.038-.956-3.453-3.809-6.113-7.367-6.789l-.037-.042C18.389 3.684 19 4.707 19 3.93c0-1.179-2.083-1.303-4 .012-1.917-1.315-4-1.191-4-.012 0 .761.583-.208 2.623 1.044C8.788 5.417 5 9.479 5 14.43c0 4.478 3.103 8.223 7.273 9.227 1.003 4.171 4.748 7.273 9.227 7.273 3.953 0 6.934-1.678 8.99-3.999.555-.626.111.602.842.235 4.24-2.132 5.168-9.861 3.885-9.861z" /><circle fill="#662113" cx="12.5" cy="13.43" r="1.5" /><path fill="#FFAC33" d="M21.81 15.93s-2 10 10 10c1 0 0 2-4 2s-9.999-5-7-11c.633-1.265 1-1 1-1z" /></svg>,
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#CCD6DD" d="M34 15c0-2-2.127-4.702-4-4-8 3-19-2-19-2-2.209 0-6.857 9.257-5 10 .277.111.541.227.799.343C4.648 20.087 4.283 21.809 6 22c9 1 6.896 14 8 14 1.344 0 2.685-2.614 3.422-5h9.8c.288 2.354.866 5 1.778 5 .866 0 2.611-3.542 3.794-9.142C33.528 24.232 34 20.326 34 15z" /><path fill="#31373D" d="M10 22c-2 0-4.946.087-6.973.087S-.617 18.609.692 17.305C2 16 6 15 5 11c-.542-2.169 4-3 6-2 4.816 2.408 5 10-2 10 0 0 3 3 1 3zm20-11c-2.586.97-5.485 1.101-8.226.838C20.669 13.231 20 15.031 20 17c0 4.418 3.357 8 7.5 8 2.587 0 4.866-1.396 6.215-3.521.181-1.872.285-4.017.285-6.479 0-2-2.127-4.702-4-4z" /><circle fill="#31373D" cx="17.5" cy="24.5" r="3.5" /><circle fill="#31373D" cx="30" cy="28" r="2" /><path fill="#CCD6DD" d="M11 9c0 .552-.671 1-1.5 1S5 7.552 5 7s2.23-.308 3 0c2.5 1 3 1.448 3 2z" /><circle fill="#CCD6DD" cx="8" cy="13" r="1" /><path fill="#31373D" d="M35 24c-.553 0-1-.447-1-1v-5c0-1.44-.561-2-2-2-.553 0-1-.448-1-1s.447-1 1-1c2.542 0 4 1.458 4 4v5c0 .553-.447 1-1 1z" /></svg>,
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#FFAC33" d="M7.44 7.503c-1-4 3.687-6 8-4 .907.421.948 1.316 0 1-3-1-6 1-4 4 1.109 1.664-3.233 2.068-4-1z" /><path fill="#FFCC4D" d="M6.136 5.785c-1-4 3.687-6 8-4 .907.421.949 1.316 0 1-3-1-6 1-4 4 1.11 1.664-3.233 2.067-4-1z" /><path fill="#E1E8ED" d="M5 14.785c0 4-2 4.827-2 4 0-2-1 0-1-1v-3c0-1.657.671-3 1.5-3s1.5 1.343 1.5 3z" /><path fill="#CCD6DD" d="M35.159 10.49c-.68-1.643-2.313-2.705-4.159-2.705-.553 0-1 .448-1 1s.447 1 1 1c1.034 0 1.941.577 2.312 1.471.341.824.168 1.758-.455 2.647-.984-1.506-2.602-2.618-4.856-2.618-2.391 0-7.279.714-10.828 1.289-.052-.094-.105-.188-.172-.289-2-3-4-8.157-7-8.157-4 0-10 4.986-10 9.157 0 2.544 5.738 2.929 7.486 2.988.697 1.43 1.414 2.934 2.232 4.33.066.205.155.429.282.683 3 6 3.119 14.5 4.5 14.5s2.5-4.857 2.5-9c0-.151-.004-.299-.007-.447 3.126.649 6.607.322 9.677-.61 1.448 5.045 1.77 10.058 2.83 10.058 1.342 0 2.433-8.818 2.494-13.12C33.316 21.226 34 19.51 34 17.785c0-.605-.086-1.23-.248-1.843 1.614-1.644 2.143-3.676 1.407-5.452z" /><circle fill="#292F33" cx="7" cy="9.285" r="1" /></svg>,
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#3B88C3" d="M32.153 24c0-1 1.523-6.212 3.047-7.735 1.522-1.523 0-3.166-1.523-3.166-3.405 0-9.139 6.901-9.139 10.901 0 5 5.733 10.424 9.139 10.424 1.523 0 3.046-1.404 1.523-2.928C33.677 29.974 32.153 26 32.153 24z" /><path fill="#3B88C3" d="M9.021 14.384c0-3.046 1.497-6.093 3.02-6.093 4.569 0 13.322 4.823 14.845 12.439 1.524 7.616-17.865-6.346-17.865-6.346zm4.854 18.278c1.523 1.523 4.57 3.047 7.617 3.047 3.046 0-3.111-4.189-1.523-6.092 2.18-2.617-6.094 3.045-6.094 3.045z" /><path d="M2.071 28.727c.761-2.285.19-3.935-1.143-5.584-1.333-1.651 3.872-1.904 5.585.381s5.713 6.281 2.158 6.22c-3.553-.065-6.6-1.017-6.6-1.017z" /><path fill="#55ACEE" d="M.168 23.488c.959.874 7.223 4.309 7.165 5.137-.058.828-2.279-.088-3.105-.279-1.485-.342-1.905-.598-2.317-.526-.84.321-.554 1.201-.242 1.704 1.498 2.61 7.286 4.662 12.16 4.662 8.412 0 16.802-7.615 16.802-10.662 0-3.046-9.345-10.663-17.757-10.663C4.483 12.86.18 18.922.168 23.488z" /><path d="M7 17c1.104 0 2 .894 2 2 0 1.105-.896 2-2 2-1.105 0-2-.896-2-2 0-1.106.895-2 2-2z" /><path fill="#269" d="M15.08 29.98c-.156 0-.314-.036-.462-.113-.49-.256-.679-.86-.423-1.35 1.585-3.034 2.218-5.768.154-9.243-.282-.475-.126-1.088.349-1.371.475-.283 1.088-.124 1.371.349 2.693 4.535 1.46 8.202-.102 11.191-.178.342-.527.537-.887.537z" /></svg>
]

const yesno_list_imgs = [
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="var(--firmgreen)" d="M34.459 1.375c-1.391-.902-3.248-.506-4.149.884L13.5 28.17l-8.198-7.58c-1.217-1.125-3.114-1.051-4.239.166-1.125 1.216-1.051 3.115.166 4.239l10.764 9.952s.309.266.452.359c.504.328 1.07.484 1.63.484.982 0 1.945-.482 2.52-1.368L35.343 5.524c.902-1.39.506-3.248-.884-4.149z" /></svg>,
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#DD2E44" d="M21.533 18.002L33.768 5.768c.976-.976.976-2.559 0-3.535-.977-.977-2.559-.977-3.535 0L17.998 14.467 5.764 2.233c-.976-.977-2.56-.977-3.535 0-.977.976-.977 2.559 0 3.535l12.234 12.234L2.201 30.265c-.977.977-.977 2.559 0 3.535.488.488 1.128.732 1.768.732s1.28-.244 1.768-.732l12.262-12.263 12.234 12.234c.488.488 1.128.732 1.768.732.64 0 1.279-.244 1.768-.732.976-.977.976-2.559 0-3.535L21.533 18.002z" /></svg>
]

const seatingchart_imgs = [
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><g fill="#FFDC5D"><path d="M28.384 6.753s-2.42-.003-2.697 1.999l-1.3 9.659c-.372 2.182 2.133 2.637 3.64 2.668 1.507.031 2.761-1.113 2.801-2.556l.104-3.046.153-4.488.045-1.449c0-1.208-.521-2.498-2.746-2.787z" /><path d="M29.25 21.906h-3.594l-.5-1.656h4.594zm-8.826-14.4s.144-.764 1.347-.68l-.332 1.051-1.015-.371z" /></g><path fill="#6D6E71" d="M29 2.365C29 1.611 28.389 1 27.635 1h-4.27C22.611 1 22 1.611 22 2.365v15.27C22 18.389 24.611 19 25.365 19h2.27c.754 0 1.365-.611 1.365-1.365V2.365z" /><path fill="#231F20" d="M28 2.365C28 1.611 27.389 1 26.635 1h-4.27C21.611 1 21 1.611 21 2.365v15.27c0 .754.611 1.365 1.365 1.365h4.27c.754 0 1.365-.611 1.365-1.365V2.365z" /><path fill="#88C9F9" d="M22 3h5v13h-5z" /><g fill="#EF9645"><path d="M20.546 14.136l.131.745.537-.045.599-.042c.49-.035.884-.37 1.022-.812l-2.289.154zm0-2.391l.02.73.651-.007c.525-.015.967-.334 1.172-.782l-1.843.059zm-.01-2.65l.011.717.223.031c.524.036.995-.238 1.242-.664l-1.476-.084zm9.61 1.344l-.159-.007c-.474-.019-.878.353-.898.827l-.073 2.506 1.766.328.132-3.103c-.122-.309-.416-.537-.768-.551z" /><path d="M30.404 11.858l-.144.067c-.43.201-.946.014-1.147-.416l-.763-1.631c-.201-.43-.014-.946.416-1.147l.144-.067c.43-.201.946-.014 1.147.416l.763 1.631c.201.43.014.946-.416 1.147z" /></g><g fill="#FFDC5D"><path d="M29.326 16.167l-.159-.007c-.474-.02-.846-.424-.827-.898l.162-3.936c.02-.474.424-.846.898-.827l.159.007c.474.02.846.424.827.898l-.162 3.936c-.019.475-.423.847-.898.827z" /><path d="M29.885 11.915l-.144.067c-.43.201-.946.014-1.147-.416l-.764-1.631c-.201-.43-.014-.946.416-1.147l.144-.068c.43-.201.946-.014 1.147.416l.763 1.631c.202.43.015.947-.415 1.148zm.933 1.865c-.785-.332-1.639-.124-1.974.114-2.887 2.044-2.462 5.208-.448 5.645 1.63.353 2.182-.789 2.182-.789l.182-3.272.058-1.698zm-9.972 1.01l.187 1.693.571-.049s.291-.037.513-.236c.156-.139.278-.356.24-.704-.094-.846-.94-.753-.94-.753l-.571.049z" /><path d="M21.049 16.481l-.031.004c-.147.021-.285-.083-.306-.23l-.162-1.151c-.021-.147.083-.285.23-.306l.031-.004c.147-.021.285.083.306.23l.162 1.151c.021.147-.083.285-.23.306zm-.354-2.112l1.486-.105s.378-.029.654-.283c.172-.159.305-.405.277-.79-.071-1.002-1.073-.931-1.073-.931l-.403.029-.599.042-.483.034.141 2.004z" /><path d="M20.713 14.368l-.037.003c-.175.012-.328-.121-.341-.296l-.097-1.368c-.012-.175.121-.328.296-.341l.037-.003c.175-.012.328.121.341.296l.097 1.368c.012.175-.121.329-.296.341zm.005-2.466l-.06.002c-.18.005-.332-.138-.337-.319l-.041-1.477c-.005-.18.138-.332.319-.337l.06-.002c.18-.005.332.138.337.319l.041 1.477c.005.18-.138.332-.319.337z" /><path d="M21.735 11.873s.358-.017.653-.234c.214-.157.396-.415.383-.862-.03-1.066-1.096-1.036-1.096-1.036l-.533.015-.514.014.06 2.133 1.047-.03zm-.396-2.525s.358.018.673-.169c.228-.135.434-.375.465-.821.074-1.064-.99-1.138-.99-1.138l-.532-.037-.148-.01-.148 2.128.68.047z" /><path d="M20.689 9.303l-.06-.004c-.18-.013-.317-.17-.305-.35l.102-1.474c.013-.18.17-.317.35-.305l.06.004c.18.013.317.17.305.35l-.102 1.474c-.013.181-.17.318-.35.305z" /></g><path fill="#FA743E" d="M29.25 21h-3.792c-.411 0-.583.203-1.198 1.211l-4.382 6.699L6.5 25.871V36h16.365c1.333 0 2.533-.307 3.035-1.542l4.633-11.626C30.958 21.5 30.197 21 29.25 21z" /></svg>,
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#9AAAB4" d="M13.503 19.693l2.828 2.828-4.95 4.95-2.828-2.829z" /><path fill="#66757F" d="M1.257 29.11l5.88-5.879c.781-.781 2.047-.781 2.828 0l2.828 2.828c.781.781.781 2.047 0 2.828l-5.879 5.879c-1.562 1.563-4.096 1.563-5.658 0-1.561-1.561-1.56-4.094.001-5.656z" /><circle fill="#8899A6" cx="22.355" cy="13.669" r="13.5" /><circle fill="#BBDDF5" cx="22.355" cy="13.669" r="9.5" /></svg>,
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#A4523A" d="M12 20c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2s2-.9 2-2V22c0-1.1-.9-2-2-2zm18 0c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2s2-.9 2-2V22c0-1.1-.9-2-2-2z" /><path fill="#C1694F" d="M13 2h16v8H13z" /><path fill="#C1694F" d="M16 9h2v13h-2zm4 0h2v13h-2zm4 0h2v13h-2zM7 23c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2s2-.9 2-2v-9c0-1.1-.9-2-2-2z" /><path fill="#C1694F" d="M25 21c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2s2-.9 2-2V23c0-1.1-.9-2-2-2zM12 0c-1.1 0-2 .9-2 2v20h4V2c0-1.1-.9-2-2-2zm18 0c-1.1 0-2 .9-2 2v20h4V2c0-1.1-.9-2-2-2z" /><path fill="#A4523A" d="M14 2h1v8h-1zm14 8h-1V2h1z" /><path fill="#D99E82" d="M30.769 20H10.341c-.223 0-.442.061-.633.175l-5.954 3.041s22.726 2.418 24.726 2.418l3.029-2.265c.309-.232.491-.597.491-.985v-1.153c0-.68-.551-1.231-1.231-1.231z" /><path fill="#A4523A" d="M16 10h2v1h-2zM5 26h4v1H5zm18 0h4v1h-4zm-3-16h2v1h-2zm4 0h2v1h-2z" /><path fill="#C1694F" d="M27.44 26H4.56C3.698 26 3 25.328 3 24.5S3.698 23 4.56 23h22.88c.862 0 1.56.672 1.56 1.5s-.698 1.5-1.56 1.5z" /></svg>
]

const digitalguestbook_imgs = [
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#77B255" d="M34.751 22c-3.382 0-11.9 3.549-15.751 7.158V17c0-.553-.447-1-1-1-.552 0-1 .447-1 1v12.341C13.247 25.669 4.491 22 1.052 22 .123 22 11.913 35.992 17 34.599V35c0 .553.448 1 1 1 .553 0 1-.447 1-1v-.356C24.188 35.638 35.668 22 34.751 22z" /><path fill="#EA596E" d="M25 13.417C25 19.768 23.293 23 18 23s-7-3.232-7-9.583S16 0 18 0s7 7.066 7 13.417z" /><path fill="#F4ABBA" d="M22.795 2c-.48 0-4.106 14.271-4.803 19.279C17.246 16.271 13.481 2 13 2c-1 0-6 9-6 13s5.707 8 11 8 10.795-4 10.795-8-5-13-6-13z" /></svg>,
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#EF9645" d="M6.203 21.641c-.078.922.321 1.198.946 1.636.618.433 4.383-2.867 5.614-3.369 1.231-.502 12.787-2.949 12.286-5.183-.501-2.234-3.993-2.564-6.683-2.108-2.69.456-7.838 2.822-9.342 4.099-1.504 1.276-2.821 4.925-2.821 4.925zm8.622 1.497s-3.557 1.155-3.557 4.155.866 4.692 1.276 5.513c.411.82 1.688 1.616 3.455.851 2.052-.889-.491-6.004 6-3.656 2.974 1.075 6.059 2.528 9.059 1.528C33.904 30.58 35 27 35 25c0-4.094-3-3-4-2s-9 3-10 3-6.175-2.862-6.175-2.862z" /><path fill="#F9CA55" d="M19.312 28.188s-.12-1.316-1.375-1.469c-1.031-.125-2.656.219-3.5 1.906-.844 1.688-2.344 1.406-2.281 2.812.062 1.406.5 2.5 1.406 2.781.907.282 2.188-.218 2.344-1.718.156-1.5.344-2.875 1.312-3.469.97-.593 2.094-.843 2.094-.843z" /><path fill="#EF9645" d="M18 26s-1-1-3-1-6.664 2.133-5.25 6.375c1 3 3.844 1.594 4.25-1.375.407-2.973 4-4 4-4z" /><path fill="#F9CA55" d="M17 26s-1-1-3-1-4.885 1.53-5 6c-.094 3.656 4.031 2 4-1-.031-3 4-4 4-4z" /><path fill="#EF9645" d="M5 27c0 3.297.457 5.286 2.428 4.947 3.269-.562 2.028-4.614 4.889-5.754 2.077-.827 5.101-.63 8.02 1.103C22.26 28.438 21 24 19 23s-8 0-9 0-5 4-5 4z" /><path fill="#F9CA55" d="M4.842 27.174C3.251 29.839 4.219 32.594 7 32c2.691-.574 1.343-4.07 4-6 1.489-1.082 4.698-1.445 6.698-.445S20 24 18 23s-8.54-.025-9.538.037c-1.909.119-3.62 4.137-3.62 4.137z" /><path fill="#3B88C3" d="M9.418 29.114c-.679.778-1.86.859-2.639.18l-.196-.171c-.779-.679-.859-1.859-.18-2.638L28.926.668c.679-.778 1.86-.859 2.639-.18l.195.171c.779.679.859 1.86.181 2.638L9.418 29.114z" /><path fill="#3B88C3" d="M10.49 27.886c-2.36 2.705-8.313 8.009-9.067 7.352-.753-.657 3.693-7.275 6.053-9.981 2.36-2.706 1.661-.542 2.493.185.832.726 2.881-.26.521 2.444z" /><path fill="#EF9645" d="M6.672 25.026c0 1 2.421 1.915 3.421.915s3.341-2.228 6.419-.941C23.716 28.01 21 24 18 23s-8 0-9 0-2.328 2.026-2.328 2.026z" /><path fill="#FFDC5D" d="M6.195 22.043c-.358-1.113 2.188-7.279 3.341-8.234 1.452-1.202 7.069-3.063 9.069-3.063S35 18 35 23s-2 5.625-4.875 6.406c-2.299.625-7.115.242-9.219-1.719C19.062 25.969 17.781 24.781 16 24c-3.302-1.448-5.503.424-6.503 1.424-2 2-5.768-.159-2.625-3.58C9.121 19.395 11.102 18.632 13 18c6-2 10-2 8-4-.707-.707-1.092.346-2.076.525-1.98.36-3.556.602-6.165 1.472-.902.3-5.172 3.023-6.564 6.046z" /><path fill="#EF9645" d="M13.196 16.275c1.064-.388 5.702-1.232 8.115-2.068 1.949-.676 3.659.636-.04 2.028-3.57 1.343-7.279 1.233-9.984 2.307-1.023.406-1.91-.875 1.909-2.267z" /><path fill="#3B88C3" d="M22.487 8.023s-5.928 6.795-8.446 9.661c2.254-.926 4.271-.75 6.198-1.884 1.927-1.133 2.806-2.342 5.73-5.695 1.086-1.244-3.482-2.082-3.482-2.082z" /></svg>,
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#31373D" d="M0 10s0-4 4-4h28s4 0 4 4v18s0 4-4 4H4s-4 0-4-4V10z" /><circle fill="#CCD6DD" cx="21" cy="19" r="10" /><circle fill="#31373D" cx="21" cy="19" r="8" /><circle fill="#3B88C3" cx="21" cy="19" r="5" /><circle fill="#FFF" cx="32.5" cy="9.5" r="1.5" /><path fill="#FFAC33" d="M16 9l3-6-6 2-4-5-2 5-6-1 4 6-5 4h6l-2 6 6-3 6 5-1-8 6-1z" /><path fill="#FFF" d="M10 14l-3 2 1-3-3-1 3-2-3-3h4l1-3 2 3 3-1-2 3 3 3-3 1 1 4z" /></svg>,
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><circle fill="#FFCC4D" cx="17" cy="19" r="17" /><ellipse fill="#664500" cx="17.999" cy="26" rx="2" ry="2.5" /><path fill="#664500" d="M8.111 21.383c-.182 0-.367-.05-.532-.154-.467-.294-.607-.911-.313-1.379.916-1.453 3.701-3.938 7.69-2.962.536.131.864.673.733 1.209-.132.536-.676.862-1.209.733-3.604-.882-5.502 2.056-5.521 2.086-.191.302-.516.467-.848.467zm11.973-3.742c-.29 0-.576-.125-.774-.366-.35-.427-.288-1.058.14-1.408 3.176-2.604 6.762-1.562 8.215-.646.467.294.607.912.312 1.379-.293.465-.908.607-1.376.315-.138-.084-3.052-1.823-5.884.499-.186.153-.41.227-.633.227z" /><path fill="#E2A62D" d="M13.346 31.273c-.068 0-.137-.009-.205-.028-.398-.113-.63-.527-.517-.926.437-1.54.258-3.029-.49-4.086-.497-.702-1.205-1.131-1.943-1.178-.414-.025-.728-.382-.702-.795s.381-.751.795-.701c1.193.074 2.313.733 3.073 1.807 1.011 1.429 1.27 3.383.709 5.361-.093.331-.394.546-.72.546zm11.037-3.061c-.142 0-.285-.04-.412-.124-1.167-.77-1.82-2.117-1.792-3.695.029-1.635.809-3.153 1.984-3.869.353-.216.814-.104 1.03.251.216.354.104.814-.251 1.03-.735.448-1.244 1.499-1.264 2.614-.02 1.055.389 1.936 1.118 2.417.346.228.441.693.213 1.039-.144.219-.382.337-.626.337z" /><path fill="#DD2E44" d="M17.179 2.72c-.043-.049-.11-.076-.189-.091 0 0-15.924-3.023-16.613-2.415C-.311.823.74 16.998.74 16.998c.005.081.023.15.067.199.604.684 4.758-2.004 9.279-6.001 4.522-3.998 7.697-7.792 7.093-8.476z" /><path fill="#EA596E" d="M.349.271C.334.301.321.342.311.394.47 1.765 2.006 13.046 2.963 16.572c1.436-.803 2.895-1.894 4.609-3.253C6.116 10.654 1.158.146.349.271z" /><path fill="#3B88C3" d="M29.902 29.229l-10.573-1.303c-1.13-.102-3.117-.112-3.015-1.902.093-1.623 2.04-1.373 3.479-1.16l10.638 1.774-.529 2.591z" /><path fill="#88C9F9" d="M30.43 26.639l-4.222-.724c-.494-.089-.934.647-.956 1.426-.025.866.227 1.304.726 1.406l4.144.512.308-2.62z" /><path fill="#3B88C3" d="M34.918 26.341l-2.622 2.411-4.687-5.097 2.622-2.411c1.361-1.252 3.499-1.162 4.751.199l.135.147c1.251 1.362 1.162 3.499-.199 4.751z" /><ellipse transform="rotate(-42.597 29.954 26.205)" fill="#88C9F9" cx="29.952" cy="26.203" rx="2.77" ry="3.462" /><ellipse transform="rotate(-42.597 29.954 26.205)" fill="#269" cx="29.952" cy="26.203" rx="1.385" ry="2.077" /><circle fill="#55ACEE" cx="2.5" cy="33.5" r="1.5" /><circle fill="#55ACEE" cx="29" cy="2" r="2" /><path fill="#EA596E" d="M4.864 29.246L2.526 23.63.412 29.675zM26 5l-4 1 1-4z" /><path fill="#77B255" d="M31.999 13L36 7.999 33 6z" /></svg>
]

const guestbook_popup_img = 'https://asset.weavebliss.com/assets/userlogin/directedline/guest_book/guestbook_popup.png'

const checklist_imgs = [
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><path fill="#DD2E44" d="M35.885 11.833c0-5.45-4.418-9.868-9.867-9.868-3.308 0-6.227 1.633-8.018 4.129-1.791-2.496-4.71-4.129-8.017-4.129-5.45 0-9.868 4.417-9.868 9.868 0 .772.098 1.52.266 2.241C1.751 22.587 11.216 31.568 18 34.034c6.783-2.466 16.249-11.447 17.617-19.959.17-.721.268-1.469.268-2.242z" /><path fill="#FDCB58" d="M34.347 23.894l-3.824-1.416-1.416-3.824c-.145-.394-.52-.654-.938-.654-.418 0-.793.26-.938.653l-1.416 3.824-3.824 1.416c-.393.144-.653.519-.653.938 0 .418.261.793.653.938l3.824 1.416 1.416 3.824c.145.393.52.653.938.653.418 0 .793-.261.938-.653l1.416-3.824 3.824-1.416c.392-.145.653-.52.653-.938 0-.418-.261-.793-.653-.937zm-23-16.001l-2.365-.875-.875-2.365C7.961 4.26 7.587 4 7.169 4c-.419 0-.793.26-.938.653l-.876 2.365-2.364.875c-.393.146-.653.52-.653.938 0 .418.26.792.653.938l2.365.875.875 2.365c.146.393.52.653.938.653.418 0 .792-.26.938-.653l.875-2.365 2.365-.875c.393-.146.653-.519.653-.938 0-.418-.26-.792-.653-.938z" /></svg>
]

const IPHONE_FRANE = `${S3CLOUD_CLOUDFRONT_USERLOGIN}2mobile.png`

function isScrolledIntoView(el, showall) {
    const { top, bottom } = el.getBoundingClientRect();
    var isVisible = (top >= 0) && ((bottom + 300) <= window.innerHeight)
    return isVisible || showall;
}

function GuestlistCycler({ guests_list_imgs, food_list_imgs, yesno_list_imgs, device }) {
    const [activeIndex, setActiveIndex] = useState(0);
    const [iconsize, setIconsize] = useState(40)
    const sections = [0, 1, 2]; // 0 = guests, 1 = food, 2 = rsvp


    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % sections.length);
        }, 2500); // 4s each cycle
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        setIconsize({ 'WEB': 40, 'TABLET': 40, 'MOBILE': 30 }[device])
    }, [device])

    return (
        <div className="DL_GUESTLISTCYCLER">
            {/* Add Guests */}
            <div className={`fade-section ${activeIndex === 0 ? "active" : ""}`}>
                <div className="DL_GUESTLISTADDGUEST">
                    <div
                        className="DL_GUESTLISTADDGUEST_ROOT"
                        style={device === 'MOBILE' ? { width: 180, height: 45 } : { width: 222, height: 50 }}
                    >
                        {iconwrapper(ADD_ICON, {
                            width: 25,
                            height: 25,
                            margin: "0px 5px",
                            display: "flex",
                            placeItems: "center",
                            alignContent: "center",
                            placeSelf: "center",
                            color: "var(--maindark)",
                        })}
                        <div className="DL_GUESTLISTIMGPROFILEROOT">
                            {guests_list_imgs.map((img, index) => {
                                return <img
                                    className="DL_GUESTLISTIMGPROFILE"
                                    key={img + '_' + index}
                                    src={img}
                                    style={{ height: iconsize, width: iconsize }}
                                />
                            })}
                        </div>
                    </div>
                    <div className="DL_GUESTLISTADDGUESTTEXT_ROOT">Add Guests</div>
                </div>
            </div>

            {/* Food Preference */}
            <div className={`fade-section ${activeIndex === 1 ? "active" : ""}`}>
                <div className="DL_GUESTLISTADDGUEST">
                    <div
                        className="DL_GUESTLISTADDGUEST_ROOT"
                        style={device === 'MOBILE' ? { width: 180, height: 45, padding: "0px 10px" } : { width: 222, height: 50, padding: "0px 10px" }}
                    >
                        {food_list_imgs.map((icon, index) => {
                            return <div key={index + 'gaddicon'}>
                                {iconwrapper(icon, {
                                    width: iconsize,
                                    height: iconsize,
                                    margin: "0px 5px",
                                    display: "flex",
                                    placeItems: "center",
                                    alignContent: "center",
                                    placeSelf: "center",
                                    color: "var(--maindark)",
                                })}
                            </div>
                        })}

                    </div>
                    <div className="DL_GUESTLISTADDGUESTTEXT_ROOT">Food Preference</div>
                </div>
            </div>

            {/* RSVP Status */}
            <div className={`fade-section ${activeIndex === 2 ? "active" : ""}`}>
                <div className="DL_GUESTLISTADDGUEST">
                    <div
                        className="DL_GUESTLISTADDGUEST_ROOT"
                        style={device === 'MOBILE' ? { width: 180, height: 45, padding: "0px 10px" } : { width: 222, height: 50, padding: "0px 10px" }}
                    >
                        {yesno_list_imgs.map((icon, index) =>
                            <div key={'yesno_' + index}>
                                {iconwrapper(icon, {
                                    width: iconsize,
                                    height: iconsize,
                                    margin: "0px 5px",
                                    display: "flex",
                                    placeItems: "center",
                                    alignContent: "center",
                                    placeSelf: "center",
                                    color: "var(--maindark)",
                                })}
                            </div>
                        )}
                    </div>
                    <div className="DL_GUESTLISTADDGUESTTEXT_ROOT">RSVP Status</div>
                </div>
            </div>
        </div>
    );
}

function ChecklistCycler() {
    const [step, setStep] = useState(0);
    const totalSteps = 5; // number of checklist elements

    useEffect(() => {
        const timer = setTimeout(() => {
            setStep((prev) => (prev + 1) % (totalSteps + 1));
        }, 800); // speed of ticking
        return () => clearTimeout(timer);
    }, [step]);

    const renderElement = (index) => {

        if (index < step) {
            if (index < 4) {
                return (
                    <div className="DL_tick">

                        {iconwrapper(TICK_ICON, {
                            width: 25,
                            height: 25,
                            color: "var(--firmgreen)",
                            backgroundColor: "rgb(208, 255, 202)",
                            borderRadius: "100%",
                        })}
                    </div>
                );
            }
            else {
                return (
                    <div className="DL_tick">
                        {iconwrapper(checklist_imgs[0], {
                            width: 25,
                            height: 25,
                            color: "var(--firmgreen)",
                            borderRadius: "100%",
                        })}
                    </div>
                );
            }
        }

        if (index < 4) {
            return <div className="DL_checklistelement" />
        }
        else {
            return null
        }

    };

    return (
        <div className="DL_checklistroot">
            {Array.from({ length: totalSteps }).map((_, i) => (
                <div key={i}>{renderElement(i)}</div>
            ))}

        </div>
    );
}

function Directedline({ titles, contents, icons, images, mimages, showall }) {

    const device = Checkdevice()
    const [scrollPos, setScrollPos] = useState(0);
    const [elemindexes, setElemindexes] = useState([])
    const [highlightindex, setHighlightindex] = useState(-1) // current selected index

    // guestbook 
    const [guestbookimgdirectedline, setGuestbookimgdirectedline] = useState(false);

    const sensor_refs = useRef([])
    sensor_refs.current = []

    const img_refs = useRef([])
    img_refs.current = []

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        var currIndexes = elemindexes.slice()
        if (elemindexes.length !== sensor_refs.current.length) {
            for (let i = 0; i < sensor_refs.current.length; i++) {
                if (!elemindexes.includes(i) && isScrolledIntoView(sensor_refs.current[i], showall)) {
                    if (img_refs.current[i]) {
                        if (i !== 0) {
                            img_refs.current[i].className = (i % 2 === 0 ? 'DL_SINGLE_IMG_LEFT_SELECTED' : 'DL_SINGLE_IMG_RIGHT_SELECTED')
                        }
                        setHighlightindex(i)
                    }
                    // this will make mobile device appear if img gt mobile device img
                }
            }
            setElemindexes(currIndexes)
        }

        var firstelem_rect = sensor_refs.current[0].getBoundingClientRect();
        if (scrollPos < firstelem_rect.top + 300) { setHighlightindex(-1) }
    }, [scrollPos])

    useEffect(() => {
        setTimeout(() => {
            setGuestbookimgdirectedline(!guestbookimgdirectedline);
        }, 3000);
    }, [guestbookimgdirectedline])

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPos(position);
    };

    const addToSensorRefs = el => {
        if (el && !sensor_refs.current.includes(el)) sensor_refs.current.push(el);
    }

    const addToImgRefs = el => {
        if (el && !img_refs.current.includes(el)) img_refs.current.push(el);
    }

    function left(title, content, icon, i, img, mimg, highlight) {

        const i_ = i + 1
        const ICON_DIV = <div className="DL_ICON">{icon}</div>
        const BTMLINE_DIV = <div className="DL_ICON_BTMLINE" style={{ width: 31 }} />
        const TITLE_DIV = <h3 className="DL_TITLE" style={{ color: (highlight && device !== 'MOBILE') ? 'var(--mainpink)' : 'var(--maindark)' }}>{title}</h3>
        const CONTENT_DIV = <h4 className={"DL_CONTENT_L_" + device + ' DL_CONTENT_ilookupcontent'}>{content}</h4>
        var IMG_DIV = <div className='DL_SINGLE_IMG_LEFT' key={'img' + i} ref={addToImgRefs} alt={''} style={{ display: 'flex', opacity: 0, width: 'max-content', height: 'max-content', position: 'relative' }}>
            {i !== 0
                ? <>
                    <img className='DL_IMG' src={img} alt={''} style={{ border: 'none' }} />
                    {mimg.length > 0
                        ? <div className={'DL_SINGLE_MIMGLEFT' + device} key={'mimg' + i} >
                            <img src={IPHONE_FRANE} alt={''} style={{ width: '100%', height: 'inherit', position: 'absolute' }} />
                        </div>
                        : null}
                </>
                : null}
        </div>
        const SENSOR_DIV = <div className='DL_SENSOR' ref={addToSensorRefs} />


        if (title === 'RSVP Website') { // 

            IMG_DIV = <div className="DL_carousel-container" ref={addToImgRefs}>
                <div className="DL_carousel-track">

                    {imgs.map((img, index) => {
                        return <div key={index + 'img'} style={{ position: 'relative', flex: '0 0 auto' }}>
                            <img src={img} height={"100%"} className="DL_carousel-img" />
                            <div className='DL_mobileroot' >
                                <img className='DL_mobileimg' src={iphone_rsvpwebsite_imgs[index]} />
                                <img className='DL_iphonestatic' src={IPHONE_FRANE} alt={''} />
                            </div>
                        </div>
                    })}

                    {imgs.map((img, index) => (
                        <div key={'dup-' + index} style={{ position: 'relative', flex: '0 0 auto' }}>
                            <img src={img} height="100%" className="DL_carousel-img" />
                            <div className="DL_mobileroot">
                                <img className="DL_mobileimg" src={iphone_rsvpwebsite_imgs[index]} />
                                <img className='DL_iphonestatic' src={IPHONE_FRANE} alt={''} />
                            </div>
                        </div>
                    ))}

                </div>
            </div>

            // var CONTENT_DIV_ = <h4 className={"DL_CONTENT_L_" + device  + ' DL_CONTENT_ilookupcontent'}>{content}</h4>


            {/* <div className='Directedline_inviationhide'/> */ }

            return (
                <div className="DL_SINGLE" key={'DL_SINGLE' + i} >
                    <div className="DL_TOP">
                        {SENSOR_DIV}
                        <div className="DL_ICON_ROOT" >
                            {ICON_DIV}
                            {BTMLINE_DIV}
                        </div>
                        <div className="DL_TITLE_N_CONTENT">
                            {TITLE_DIV}
                            {CONTENT_DIV}
                            {IMG_DIV}
                        </div>
                    </div>
                    {titles.length !== i_
                        ? <div className="DL_BTM" >
                            <div className="DL_TOPRIGHT DL_TOPRIGHT_1" >
                                <div className='DL_TOPRIGHT_CORNER_1' />
                            </div>
                            <div className="DL_MID" />
                            <div className="DL_BTMLEFT DL_BTMLEFT_1" >
                                <div className='DL_BTMLEFT_CORNER_1' />
                            </div>
                        </div>
                        : <div className="DL_ICON DL_ICON_1">{iconwrapper(HEARTUSERLOGIN_ICON, { width: 33, height: 33 })}</div>}

                </div>
            )

        }
        else if (title === 'Seating Chart') {

            IMG_DIV = <div className='DL_SINGLE_IMG_LEFT' key={'img' + i} ref={addToImgRefs} alt={''} style={{ display: 'flex', opacity: 0, width: 'max-content', height: 'max-content', position: 'relative' }}>
                {i !== 0
                    ? <>
                        <img className='DL_IMG' src={img} alt={''} style={{ border: 'none' }} />
                        {mimg.length > 0
                            ? <div className={'DL_SINGLE_MIMGLEFT' + device} key={'mimg' + i} >
                                <img src={IPHONE_FRANE} alt={''} style={{ width: '100%', height: 'inherit', position: 'absolute' }} />
                            </div>
                            : null}
                    </>
                    : null}

                {/* <div className='DL_seatingchartexplainroot'>
                    <div className='DL_seatingchartitem'>
                        <div className='DL_seatingcharticon'>🤳</div>
                        <div>
                            {`Scan
                        QR`}
                        </div>
                    </div>
                    <div className='DL_seatingchartitem'>
                        <div className='DL_seatingcharticon'>🔎</div>
                        <div>
                            {`Search
                        Names`}
                        </div>
                    </div>
                    <div className='DL_seatingchartitem'>
                        <div className='DL_seatingcharticon'>🪑</div>
                        {`Get
                        Seated`}
                    </div>
                </div> */}

                <div className='DL_seatingchartexplainroot'>
                    <div className='DL_seatingchartitem'>
                        {iconwrapper(
                            seatingchart_imgs[0],
                            { width: 30, height: 30, margin: "10px 0px", display: "flex", placeItems: "center", alignContent: "center", placeSelf: "center", padding: 5, borderRadius: 60, backgroundColor: '#fff' }
                        )}
                        <div>
                            {`Scan
                        QR`}
                        </div>
                    </div>
                    <div className='DL_seatingchartitem'>
                        {iconwrapper(
                            seatingchart_imgs[1],
                            { width: 30, height: 30, margin: "10px 0px", display: "flex", placeItems: "center", alignContent: "center", placeSelf: "center", padding: 5, borderRadius: 60, backgroundColor: '#fff' }
                        )}
                        <div>
                            {`Search
                        Names`}
                        </div>
                    </div>
                    <div className='DL_seatingchartitem'>
                        {iconwrapper(
                            seatingchart_imgs[2],
                            { width: 30, height: 30, margin: "10px 0px", display: "flex", placeItems: "center", alignContent: "center", placeSelf: "center", padding: 5, borderRadius: 60, backgroundColor: '#fff' }
                        )}
                        {`Get
                        Seated`}
                    </div>
                </div>

                {/* <div className='DL_seatingchartexplainroot'>
                    <div className='DL_seatingchartitem'>
                        {iconwrapper(
                            seatingchart_imgs[0],
                            {
                                width: 40,
                                height: 40,
                                margin: "0px 5px",
                                display: "flex",
                                placeItems: "center",
                                alignContent: "center",
                                placeSelf: "center",
                                color: "var(--maindark)",
                            }
                        )}
                        Scan QR
                    </div>
                    <div className='DL_seatingchartitem'>
                    {iconwrapper(
                            seatingchart_imgs[1],
                            {
                                width: 40,
                                height: 40,
                                margin: "0px 5px",
                                display: "flex",
                                placeItems: "center",
                                alignContent: "center",
                                placeSelf: "center",
                                color: "var(--maindark)",
                            }
                        )}
                        Search Names
                    </div>
                    <div className='DL_seatingchartitem'>
                    {iconwrapper(
                            seatingchart_imgs[2],
                            {
                                width: 40,
                                height: 40,
                                margin: "0px 5px",
                                display: "flex",
                                placeItems: "center",
                                alignContent: "center",
                                placeSelf: "center",
                                color: "var(--maindark)",
                            }
                        )}
                        Get Seated
                    </div>
                </div> */}
            </div>

            return (
                <div className="DL_SINGLE" key={'DL_SINGLE' + i}>
                    <div className="DL_TOP">
                        {SENSOR_DIV}
                        <div className="DL_ICON_ROOT" >
                            {ICON_DIV}
                            {BTMLINE_DIV}
                        </div>
                        <div className="DL_TITLE_N_CONTENT">
                            {TITLE_DIV}
                            {CONTENT_DIV}
                            {IMG_DIV}
                        </div>
                    </div>
                    {titles.length !== i_
                        ? <div className="DL_BTM" >
                            <div className="DL_TOPRIGHT DL_TOPRIGHT_1" >
                                <div className='DL_TOPRIGHT_CORNER_1' />
                            </div>
                            <div className="DL_MID" />
                            <div className="DL_BTMLEFT DL_BTMLEFT_1" >
                                <div className='DL_BTMLEFT_CORNER_1' />
                            </div>
                        </div>
                        : <div className="DL_ICON DL_ICON_1">{iconwrapper(HEARTUSERLOGIN_ICON, { width: 33, height: 33 })}</div>}
                </div>
            )
        }
        else if (title === 'Checklist') {

            IMG_DIV = <div className='DL_SINGLE_IMG_LEFT' key={'img' + i} ref={addToImgRefs} alt={''} style={{ display: 'flex', opacity: 0, width: 'max-content', height: 'max-content', position: 'relative' }}>
                {i !== 0
                    ? <>
                        <img className='DL_IMG' src={img} alt={''} style={{ border: 'none' }} />
                        {mimg.length > 0
                            ? <div className={'DL_SINGLE_MIMGLEFT' + device} key={'mimg' + i} >
                                <img src={IPHONE_FRANE} alt={''} style={{ width: '100%', height: 'inherit', position: 'absolute' }} />
                            </div>
                            : null}
                    </>
                    : null}
                <ChecklistCycler />
            </div>

            return (
                <div className="DL_SINGLE" key={'DL_SINGLE' + i}>
                    <div className="DL_TOP">
                        {SENSOR_DIV}
                        <div className="DL_ICON_ROOT" >
                            {ICON_DIV}
                            {BTMLINE_DIV}
                        </div>
                        <div className="DL_TITLE_N_CONTENT">
                            {TITLE_DIV}
                            {CONTENT_DIV}
                            {IMG_DIV}
                        </div>
                    </div>
                    {titles.length !== i_
                        ? <div className="DL_BTM" >
                            <div className="DL_TOPRIGHT DL_TOPRIGHT_1" >
                                <div className='DL_TOPRIGHT_CORNER_1' />
                            </div>
                            <div className="DL_MID" />
                            <div className="DL_BTMLEFT DL_BTMLEFT_1" >
                                <div className='DL_BTMLEFT_CORNER_1' />
                            </div>
                        </div>
                        : <div className="DL_ICON DL_ICON_1">{iconwrapper(HEARTUSERLOGIN_ICON, { width: 33, height: 33 })}</div>}
                </div>
            )
        }
        else {
            return (
                <div className="DL_SINGLE" key={'DL_SINGLE' + i}>
                    <div className="DL_TOP">
                        {SENSOR_DIV}
                        <div className="DL_ICON_ROOT" >
                            {ICON_DIV}
                            {BTMLINE_DIV}
                        </div>
                        <div className="DL_TITLE_N_CONTENT">
                            {TITLE_DIV}
                            {CONTENT_DIV}
                            {IMG_DIV}
                        </div>
                    </div>
                    {titles.length !== i_
                        ? <div className="DL_BTM" >
                            <div className="DL_TOPRIGHT DL_TOPRIGHT_1" >
                                <div className='DL_TOPRIGHT_CORNER_1' />
                            </div>
                            <div className="DL_MID" />
                            <div className="DL_BTMLEFT DL_BTMLEFT_1" >
                                <div className='DL_BTMLEFT_CORNER_1' />
                            </div>
                        </div>
                        : <div className="DL_ICON DL_ICON_1">{iconwrapper(HEARTUSERLOGIN_ICON, { width: 33, height: 33 })}</div>}
                </div>
            )
        }

    }

    function right(title, content, icon, i, img, mimg, highlight) {
        const i_ = i + 1
        const ICON_DIV = <div className="DL_ICON">{icon}</div>
        const BTMLINE_DIV = <div className="DL_ICON_BTMLINE" style={{ width: 30 }} />
        const TITLE_DIV = <h3 className="DL_TITLE" style={{ placeContent: 'flex-end', color: (highlight && device !== 'MOBILE') ? 'var(--mainpink)' : 'var(--maindark)' }}>{title}</h3>
        const CONTENT_DIV = <h4 className={"DL_CONTENT_R_" + device + ' DL_CONTENT_ilookupcontent'} style={{ placeSelf: 'flex-end', textAlign: 'end' }}>{content}</h4>
        let IMG_DIV = <div className='DL_SINGLE_IMG' key={'img' + i} ref={addToImgRefs} alt={''} style={{ display: 'flex', opacity: 0, width: 'max-content', height: 'max-content', position: 'relative', alignSelf: 'flex-end', }}>
            <img className='DL_IMG' src={img} alt={''} style={{ border: 'none' }} />
            {mimg.length > 0
                ? <div className={'DL_SINGLE_MIMGRIGHT' + device} key={'mimg' + i} >
                    <img src={IPHONE_FRANE} alt={''} style={{ width: '100%', height: 'inherit', position: 'absolute' }} />
                </div>
                : null}
        </div>
        const SENSOR_DIV = <div className="DL_SENSOR" ref={addToSensorRefs} />

        if (title === 'Guest List') {

            IMG_DIV = <div className='DL_SINGLE_IMG' key={'img' + i} ref={addToImgRefs} alt={''} style={{ display: 'flex', opacity: 0, width: 'max-content', height: 'max-content', position: 'relative', alignSelf: 'flex-end', }}>
                <img className='DL_IMG' src={img} alt={''} style={{ border: 'none' }} />
                {mimg.length > 0
                    ? <div className={'DL_SINGLE_MIMGRIGHT' + device} key={'mimg' + i} >
                        <img src={IPHONE_FRANE} alt={''} style={{ width: '100%', height: 'inherit', position: 'absolute' }} />
                    </div>
                    : null}

                <GuestlistCycler
                    guests_list_imgs={guests_list_imgs}
                    food_list_imgs={food_list_imgs}
                    yesno_list_imgs={yesno_list_imgs}
                    device={device}
                />

            </div>

            return (
                <div className="DL_SINGLE" key={'DL_SINGLE' + i} style={{ alignItems: 'flex-end' }}>
                    <div className="DL_TOP">
                        <div className="DL_TITLE_N_CONTENT">
                            {TITLE_DIV}
                            {CONTENT_DIV}
                            {IMG_DIV}

                        </div>
                        {SENSOR_DIV}
                        <div className="DL_ICON_ROOT" >
                            {ICON_DIV}
                            {BTMLINE_DIV}
                        </div>
                    </div>
                    {titles.length !== i_
                        ? <div className="DL_BTM" >
                            <div className="DL_BTMLEFT DL_BTMLEFT_2" >
                                <div className='DL_BTMLEFT_CORNER_2' />
                            </div>
                            <div className="DL_MID" />
                            <div className="DL_TOPRIGHT DL_TOPRIGHT_2" >
                                <div className='DL_TOPRIGHT_CORNER_2' />
                            </div>
                        </div>
                        : <div className="DL_ICON DL_ICON_1">{iconwrapper(HEARTUSERLOGIN_ICON, { width: 33, height: 33 })}</div>}
                </div>
            )
        }
        else if (title === 'Digital Guestbook') {

            const DIGITAL_GUESTBOOK_UNIQUE_DIV = <div className='DL_digitalguestbook_root'>
                <div className='DL_digitalguestbook_row'>
                    <div className='DL_digitalguestbook_item'>
                        <div className='DL_digitalguestnumber'>1</div>
                        {iconwrapper(
                            digitalguestbook_imgs[0],
                            { width: 30, height: 30, margin: "10px 5px 10px 0px", display: "flex", placeItems: "center", alignContent: "center", placeSelf: "center", padding: 5, borderRadius: 60, backgroundColor: '#fff' }
                        )}
                        <div>{`Sketch & Doodle`}</div>
                    </div>
                    <div className='DL_digitalguestbook_item'>
                        <div className='DL_digitalguestnumber'>2</div>
                        {iconwrapper(
                            digitalguestbook_imgs[1],
                            { width: 30, height: 30, margin: "10px 5px 10px 0px", display: "flex", placeItems: "center", alignContent: "center", placeSelf: "center", padding: 5, borderRadius: 60, backgroundColor: '#fff' }
                        )}
                        <div>{`Leave a Message`}</div>
                    </div>
                </div>
                <div className='DL_digitalguestbook_row'>

                    <div className='DL_digitalguestbook_item'>
                        <div className='DL_digitalguestnumber'>3</div>

                        {iconwrapper(
                            digitalguestbook_imgs[2],
                            { width: 30, height: 30, margin: "10px 5px 10px 0px", display: "flex", placeItems: "center", alignContent: "center", placeSelf: "center", padding: 5, borderRadius: 60, backgroundColor: '#fff' }
                        )}
                        <div>{`Capture the Moment`}</div>
                    </div>
                    <div className='DL_digitalguestbook_item'>
                        <div className='DL_digitalguestnumber'>4</div>

                        {iconwrapper(
                            digitalguestbook_imgs[3],
                            { width: 30, height: 30, margin: "10px 5px 10px 0px", display: "flex", placeItems: "center", alignContent: "center", placeSelf: "center", padding: 5, borderRadius: 60, backgroundColor: '#fff' }
                        )}
                        <div>{`Enjoy the Moments`}</div>
                    </div>

                </div>

            </div>

            IMG_DIV = <div className='DL_SINGLE_IMG' key={'img' + i} ref={addToImgRefs} alt={''} style={{ display: 'flex', opacity: 0, width: 'max-content', height: 'max-content', position: 'relative', alignSelf: 'flex-end', }}>
                <img
                    className='DL_IMG'
                    onLoad={() => {
                        setGuestbookimgdirectedline(true);
                    }}
                    src={img}
                    alt={''}
                    style={{ border: 'none' }}
                />
                {mimg.length > 0
                    ? <div className={'DL_SINGLE_MIMGRIGHT' + device} key={'mimg' + i} >
                        <img src={IPHONE_FRANE} alt={''} style={{ width: '100%', height: 'inherit', position: 'absolute' }} />
                    </div>
                    : null}
                {guestbookimgdirectedline
                    ? <img
                        id='DL_guestbookoverlay'
                        className='DL_IMG'
                        src={guestbook_popup_img}
                        alt={''}
                    />
                    : null}
            </div>

            // const FINDOUTMORE_DIV = <div style={{ width: '100%', display: 'flex', position: 'relative', placeContent: 'flex-end' }}>
            //     <button
            //         onClick={() => {

            //          }}
            //         style={{ right: 0, position: 'relative', padding: 10, marginTop: 10, border: '1px solid var(--maindark)', borderRadius: '0.5em', backgroundColor: '#ffffff', display: 'flex', flexDirection: 'row', placeItems: 'center' }}
            //     >
            //         <div style={{ touchAction: 'manipulation' }}>Click to Find Out More!</div>
            //         {iconwrapper(RIGHTARROW_ICON, { width: 15, height: 15, transform: 'rotate( -90deg )', touchAction: 'manipulation' })}
            //     </button>
            // </div>
            const FINDOUTMORE_DIV = <div style={{ width: '100%', display: 'flex', position: 'relative', placeContent: 'flex-end' }}>
                <button
                    onClick={() => {
                        window.open(
                            // "https://www.neopets.com", 
                            production ? "http://weavebliss.com/guestbook-how-it-works" : "http://192.168.1.14:3001/guestbook-how-it-works",
                            "_blank",
                            "noopener,noreferrer"
                        );
                    }}
                    style={{ width:215, placeContent:'center',right: 0, position: 'relative', padding: 10, marginTop: 10, border: '1px solid var(--mainpink)', borderRadius: '0.5em', backgroundColor: 'var(--mainpink)', color: '#ffffff', display: 'flex', flexDirection: 'row', placeItems: 'center' }}
                >
                    <div style={{ touchAction: 'manipulation', fontSize: 16 }}>Click to Find Out More!</div>
                    {iconwrapper(RIGHTARROW_ICON, { width: 15, height: 15, transform: 'rotate( -90deg )', touchAction: 'manipulation' })}
                </button>
            </div>
            return (
                <div className="DL_SINGLE" key={'DL_SINGLE' + i} style={{ alignItems: 'flex-end' }}>
                    <div className="DL_TOP">
                        <div className="DL_TITLE_N_CONTENT">
                            {TITLE_DIV}
                            {CONTENT_DIV}
                            {DIGITAL_GUESTBOOK_UNIQUE_DIV}
                            {IMG_DIV}
                            {FINDOUTMORE_DIV}

                        </div>
                        {SENSOR_DIV}
                        <div className="DL_ICON_ROOT" >
                            {ICON_DIV}
                            {BTMLINE_DIV}
                        </div>
                    </div>
                    {titles.length !== i_
                        ? <div className="DL_BTM" >
                            <div className="DL_BTMLEFT DL_BTMLEFT_2" >
                                <div className='DL_BTMLEFT_CORNER_2' />
                            </div>
                            <div className="DL_MID" />
                            <div className="DL_TOPRIGHT DL_TOPRIGHT_2" >
                                <div className='DL_TOPRIGHT_CORNER_2' />
                            </div>
                        </div>
                        : <div className="DL_ICON DL_ICON_1">{iconwrapper(HEARTUSERLOGIN_ICON, { width: 33, height: 33 })}</div>}
                </div>
            )
        }
        else if (title === 'Vendor & Venue') {
            return (
                <div className="DL_SINGLE" key={'DL_SINGLE' + i} style={{ alignItems: 'flex-end' }}>
                    <div className="DL_TOP">
                        <div className="DL_TITLE_N_CONTENT">
                            {TITLE_DIV}
                            {CONTENT_DIV}



                            <div className="DL_VENDOR_ROOT DL_CONTENT_ilookupcontent">
                                <div className="DL_VENDOR_SCROLL">
                                    {HOME_COLLECTION_VENDORTYPE_WEDDING.filter(item => item.value !== "All").map((item, index) => (
                                        <div key={index + "vt"} className="DL_VENDOR_ITEM">
                                            {iconwrapper(item.icon, { width: 30, height: 30 })}
                                        </div>
                                    ))}
                                    {/* Duplicate items for seamless loop */}
                                    {HOME_COLLECTION_VENDORTYPE_WEDDING.filter(item => item.value !== "All").map((item, index) => (
                                        <div key={index + "vt-duplicate"} className="DL_VENDOR_ITEM">
                                            {iconwrapper(item.icon, { width: 30, height: 30 })}
                                        </div>
                                    ))}
                                </div>
                            </div>







                            {IMG_DIV}
                        </div>
                        {SENSOR_DIV}
                        <div className="DL_ICON_ROOT" >
                            {ICON_DIV}
                            {BTMLINE_DIV}
                        </div>
                    </div>
                    {titles.length !== i_
                        ? <div className="DL_BTM" >
                            <div className="DL_BTMLEFT DL_BTMLEFT_2" >
                                <div className='DL_BTMLEFT_CORNER_2' />
                            </div>
                            <div className="DL_MID" />
                            <div className="DL_TOPRIGHT DL_TOPRIGHT_2" >
                                <div className='DL_TOPRIGHT_CORNER_2' />
                            </div>
                        </div>
                        : <div className="DL_ICON DL_ICON_1">{iconwrapper(HEARTUSERLOGIN_ICON, { width: 33, height: 33 })}</div>}
                </div>
            )
        }
        else {
            return (
                <div className="DL_SINGLE" key={'DL_SINGLE' + i} style={{ alignItems: 'flex-end' }}>
                    <div className="DL_TOP">
                        <div className="DL_TITLE_N_CONTENT">
                            {TITLE_DIV}
                            {CONTENT_DIV}
                            {IMG_DIV}
                        </div>
                        {SENSOR_DIV}
                        <div className="DL_ICON_ROOT" >
                            {ICON_DIV}
                            {BTMLINE_DIV}
                        </div>
                    </div>
                    {titles.length !== i_
                        ? <div className="DL_BTM" >
                            <div className="DL_BTMLEFT DL_BTMLEFT_2" >
                                <div className='DL_BTMLEFT_CORNER_2' />
                            </div>
                            <div className="DL_MID" />
                            <div className="DL_TOPRIGHT DL_TOPRIGHT_2" >
                                <div className='DL_TOPRIGHT_CORNER_2' />
                            </div>
                        </div>
                        : <div className="DL_ICON DL_ICON_1">{iconwrapper(HEARTUSERLOGIN_ICON, { width: 33, height: 33 })}</div>}
                </div>
            )
        }

    }

    return (
        <div className="DL_ROOT">
            {parseInt(highlightindex) > -1 && device === 'WEB'
                ? <div className='DL_WEBMENU'>
                    {titles.map((title, i) => <div key={'menu_' + title + '_' + i} className={highlightindex === i ? 'DL_SELECTEDTITLE' : 'DL_NONSELECTEDTITLE'}>{title}</div>)}
                </div>
                : null}
            {titles.map((title, i) => i % 2 === 0
                ? left(title, contents[i], icons[i], i, images[i], mimages[i], highlightindex === i)
                : right(title, contents[i], icons[i], i, images[i], mimages[i], highlightindex === i))}
        </div>
    )
}

export default Directedline